var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.166992 14.0003C0.166992 6.63969 6.13969 0.666992 13.5003 0.666992C20.861 0.666992 26.8337 6.63969 26.8337 14.0003C26.8337 21.361 20.861 27.3337 13.5003 27.3337C6.13969 27.3337 0.166992 21.361 0.166992 14.0003ZM2.38921 14.0003C2.38921 7.86699 7.36699 2.88921 13.5003 2.88921C19.6337 2.88921 24.6114 7.86699 24.6114 14.0003C24.6114 20.1337 19.6337 25.1114 13.5003 25.1114C7.36699 25.1114 2.38921 20.1337 2.38921 14.0003ZM12.3892 17.3337V19.5559H14.6114V17.3337H12.3892ZM12.3892 15.1114H14.6114V8.44477H12.3892V15.1114Z",
    fill: "#89A6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningBlueIcon);
export default __webpack_public_path__ + "static/media/warning-blue-icon.e3fdb5c1354fd7f5f57e3ea0d5894a92.svg";
export { ForwardRef as ReactComponent };